export const styles = {
  card: {
    maxWidth: '40%',
    height: 300,
    display: 'block',
    margin: 'auto',
    marginTop: '3rem',
    boxShadow: "-0.313em 0.625em 0.5em 0.500em #888888 !important"
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#123C69',
    marginBottom: 20
  },
  textfields: {
    width: '100%'
  },
  buttons: {
    marginTop: 20
  },
  buttonA: {
    float: 'left'
  },
  buttonB: {
    marginTop: 25,
    float: 'right',
    backgroundColor: '#123C69',
    color: 'white',
    padding: 15,
    borderRadius: 10,
    fontSize: 15,
  },
  checkBox: {
    marginTop: 10,
    marginLeft: -15
  },
  loginmessage: {
    color: 'red',
    marginLeft: '15px'
  }
};



// WEBPACK FOOTER //
// ./src/components/logincard/style.js